import { Injectable, Inject } from '@angular/core'
import { NavigationStart, Router } from '@angular/router'
import { LocalStorage, LocalStorageService } from 'ngx-store'
import { BootstrapData, ElementsUser } from 'elements-sdk'

import { BOOTSTRAP_DATA } from 'api/module'
import { IdentityService, KnownPage, KnownPageGroup } from 'main/services/identity.service'
import { LicenseService } from 'common/util/services/license.service'

@Injectable({ providedIn: 'root' })
export class AppSidebarService {
  hidden = false

  @LocalStorage('collapsed') collapsed = true

  constructor (
    private localStorage: LocalStorageService,
    private identity: IdentityService,
    private license: LicenseService,
    private router: Router,
    @Inject(BOOTSTRAP_DATA) private bootstrapData: BootstrapData,
  ) {
    this.updateHidden()
    identity.identityUpdated$.subscribe(() => this.updateHidden())

    router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        if (!this.collapsed && document.body.clientWidth < 992) {
          this.toggle()
        }
      }
    })
  }

  private updateHidden () {
    this.hidden = this.identity.getAvailablePages(this.identity.user as ElementsUser).length < 2
    if (this.identity.hasPermission('cloud:access') && this.bootstrapData.cloudConnections.length > 0) {
      this.hidden = false
    }
  }

  toggle (): void {
    this.collapsed = !this.collapsed
  }

  havePagePermission (page: KnownPage): boolean {
    const user = this.identity.user
    if (!user) {
      return false
    }
    return this.identity.hasPagePermission(user as ElementsUser, page)
  }

  haveCategoryPermission (category: KnownPageGroup): boolean {
    if (category.component &&
        !this.license.hasComponent(category.component)
    ) {
      return false
    }

    for (const page of category.pages) {
      if (this.havePagePermission(page)) {
        return true
      }
    }

    return false
  }

  isCategoryExpanded (category: KnownPageGroup): boolean {
    return this.localStorage.get(`categoryExpanded_${category.name}`) ?? false
  }

  toggleCategoryExpanded (category: KnownPageGroup): void {
    this.localStorage.set(`categoryExpanded_${category.name}`, !this.isCategoryExpanded(category))
  }
}
